import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme, _params, getRef) => ({
  simpleGrid: {
    alignItems: "center"
  }
}));

export default useStyles;